export default class AlarmDialogController {
    /* @ngInject */
    constructor($log, $routeParams, $q, EventsService) {
        this.$log = $log;
        this.$routeParams = $routeParams;
        this.$q = $q;
        this.EventsService = EventsService;
        this.alarms = [];
        this.latestUniqueAlarms = [];
    }

    $onInit() {
        this.getAlarmsToAcknowledge();
    }

    getAlarmsToAcknowledge() {
        // Get thing's all un-acknowledged alarms from a year back
        const params = {
            thingId: this.$routeParams.id,
            fromDate: (new Date()).setMonth(-12),
            toDate: (new Date()).valueOf(),
        };

        this.EventsService.getEventsToAcknowledge(params)
            .then((response) => {
                if (response.hits.hits.length !== 0) {
                    this.alarms = response.hits.hits;

                    // Pick first alarm for unique rules. Response assumed ordered on timestamp descending
                    this.latestUniqueAlarms = this.alarms.filter((alarm, index, self) =>
                        self.findIndex(t => t._source.source.rule === alarm._source.source.rule) === index);

                    // Add boolean to each unigue alarm. Used by spinner when acknowledging.
                    this.latestUniqueAlarms.forEach((l) => { l.isAcknowledging = false; });
                } else {
                    this.alarms = [];
                }
            });
    }

    acknowledgeAlarmsForRule(alarmEvent) {
        alarmEvent.isAcknowledging = true;

        // Filter out all alarms for current rule
        const ruleAlarms = this.alarms.filter(a => a._source.source.rule === alarmEvent._source.source.rule);

        // Acknowledge the events and resolve the promises
        const promises = [];
        ruleAlarms.map(alarm =>
            promises.push(this.EventsService.acknowledgeEvent(alarm)),
        );

        this.$q.all(promises)
            .then(() => {
                // 'refresh' list of alarms to acknowledge
                this.getAlarmsToAcknowledge();
            })
            .catch((error) => {
                this.$log.info(`Failed to acknowledge alarms: ${error}`);
            });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/alarm-notifications/alarm-notifications.controller.js